import { Button } from "@chef/components";
import { AppShell } from "@chef/feature-app-shell";
import { Check } from "@chef/icons/small";
import { useBillingQuery } from "@chef/state-management";

import { intl } from "./DeleteAccountRequestSuccessPage.intl";

export const DeleteAccountRequestSuccessPage = () => {
  const { refetch } = useBillingQuery();
  return (
    <AppShell title={intl.DELETE_ACCOUNT}>
      <AppShell.Meta />
      <AppShell.Main grid>
        <div className="flex flex-col items-center gap-6 text-center col-span-full md:col-span-6 md:col-start-2 lg:col-span-4 lg:col-start-3 xl:col-start-5 md:mt-48">
          <div className="flex items-center justify-center py-8 rounded-full bg-grey-3 px-7">
            <Check className="w-10 h-8" />
          </div>

          <h1 className="text-2xl">
            <strong>
              {intl.YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_IS_BEING_PROCESSED}
            </strong>
          </h1>

          <p className="mt-2">
            {intl.WE_WILL_CONTACT_YOU_WHEN_REQUEST_IS_PROCESSED}
          </p>

          <Button primary onClick={refetch}>
            {intl.I_UNDERSTAND}
          </Button>
        </div>
      </AppShell.Main>
      <AppShell.TabBar />
    </AppShell>
  );
};
